import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PdfUtils } from "src/app/shared/utils/pdf-utils";
import { KmlUtils } from "src/app/shared/utils/kml-utils";
import { PptxUtils } from "src/app/shared/utils/pptx-utils";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { from, Subscription } from "rxjs";
import { concatMap, take, map, finalize } from "rxjs/operators";
import { Obra } from "src/app/models/entities/obra";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { SegmentoService } from "src/app/services/segmento.service";
import { Segmento } from "src/app/models/entities/segmento";
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { AngularFireStorage } from "@angular/fire/storage";
import { LoaderService } from "src/app/services/loader.service";
import { DocumentoObraService } from "src/app/services/documento-obra.service";
import { DocumentoObra } from "src/app/models/entities/documento-obra";

@Component({
  selector: "modal-ficha-tecnica",
  templateUrl: "./modal-ficha-tecnica.component.html",
  styleUrls: ["./modal-ficha-tecnica.component.scss"],
})
export class ModalFichaTecnicaComponent implements OnInit, OnDestroy {
  public obraSeleccionada: ObraDTO;
  public elementosObra: Segmento[] = [];
  public TIPO_OBRA_PROCESO: string = "0";

  @ViewChild("modalFichaTecnica")
  public modalFichaTecnica: any;

  public modalActivo: NgbModalRef;

  @Input("mostrarBtnGuardarFormato")
  public mostrarBtnGuardarFormato: boolean = false;

  @Output()
  public guardarFormatoListener: EventEmitter<Obra> = new EventEmitter<Obra>();

  public suscripcionStorage: Subscription;

  reportServer: string = "https://198.37.117.136/";
  reportUrl: string = "";
  showParameters: string = "true";
  toolbar: string = "false";
  width: number = 100;
  height: number = 100;
  parameters: any = {
    parameterMario: "-M0czv2ETd0h70ndgVXt",
  };

  constructor(
    private modalService: NgbModal,
    private pdfUtils: PdfUtils,
    private kmlUtils: KmlUtils,
    private pptxUtils: PptxUtils,
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private storage: AngularFireStorage,
    private loaderService: LoaderService,
    private documentoObraService: DocumentoObraService
  ) {}

  public ngOnInit(): void {}

  public abrirModal(obra: ObraDTO): void {
    this.obraSeleccionada = obra;
    this.modalActivo = this.modalService.open(this.modalFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
    this.reportUrl = `Default.aspx`;
    this.parameters.parameterMario = this.obraSeleccionada.obra.keyLevantamientoObra;

    console.log(this.reportServer);
    console.log(this.reportUrl);
  }

  public abrirModalPersonalizado(
    obra: Obra,
    nombreTramoLicitacion: string,
    nombreObra: string,
    nombreEstado: string,
    keyDireccionAdjunta: string
  ): void {
    let datosObra: ObraDTO = new ObraDTO();
    datosObra.obra = obra;
    datosObra.nombreTramoLicitacion = nombreTramoLicitacion;
    datosObra.nombreObra = nombreObra;
    datosObra.nombreEstado = nombreEstado;
    datosObra.keyCatDireccionAdjunta = keyDireccionAdjunta;
    this.obraSeleccionada = datosObra;
    // this.reportUrl = `?keyLevantamiento=${this.obraSeleccionada.obra.keyLevantamientoObra}`;
    // this.parameters.parameterMario = this.obraSeleccionada.obra.keyLevantamientoObra;
    this.modalActivo = this.modalService.open(this.modalFichaTecnica, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });
    // console.log(this.reportServer);
    // console.log(this.reportUrl);
  }

  public descargar(): void {
    if (this.obraSeleccionada.obra.incluyeImagenes) {
      // this.pdfUtils.descargarPdf(); //COMENTADA PORQUE AUN NO HAY IMAGENES
      // this.pdfUtils.descargarFichaSinImagenes();
      this.generarPDF();
    } else {
      // this.pdfUtils.descargarFichaSinImagenes();
      this.generarPDF();
    }
  }

  public async generarPDF(): Promise<void> {
    this.loaderService.activarLoaderScreen("Generando ficha");
    let pdf: jsPDF = await this.crearPdf();
    let documentosObra: DocumentoObra[] = await this.documentoObraService
      .findByKeyObra(this.obraSeleccionada.obra.keyLevantamientoObra)
      .pipe(take(1))
      .toPromise();
    let ficha: DocumentoObra = documentosObra.find(
      (d: DocumentoObra) => d.tipo === "ficha"
    );
    if (ficha) {
      await this.documentoObraService.delete(ficha.key);
      await this.storage.storage.refFromURL(ficha.urlDescarga).delete();
    }
    let blob = pdf.output("blob");
    let nombreArchivo: string = Date.now().toString();
    let rutaStorage: string = "/documentos/fichas/" + nombreArchivo + ".pdf";
    let ref = this.storage.ref(rutaStorage);
    let tarea = this.storage.upload(rutaStorage, blob);
    tarea
      .snapshotChanges()
      .pipe(
        finalize(async () => {
          let urlDescarga = await ref.getDownloadURL().toPromise();
          let documentoObra: DocumentoObra = {
            keyLevantamientoObra: this.obraSeleccionada.obra
              .keyLevantamientoObra,
            tipo: "ficha",
            rutaStorage,
            urlDescarga,
            fechaCreacion: new Date().getTime(),
            fechaActualizacion: new Date().getTime(),
          };
          await this.documentoObraService.save(documentoObra);
          this.loaderService.desactivarLoaderScreen();
          pdf.save(`${nombreArchivo}.pdf`);
        })
      )
      .subscribe();
  }

  public async crearPdf(): Promise<jsPDF> {
    let pdf = new jsPDF("l", "cm", "letter", true);
    let width = pdf.internal.pageSize.getWidth();
    let height = pdf.internal.pageSize.getHeight();
    let configuracionCanvas = {
      allowTaint: true,
      useCORS: true,
      scale: 5,
      ignoreElements: function (element) {
        return element.classList.contains("gm-style-mtc") ? true : false;
      },
    };
    let canvas: HTMLCanvasElement = await html2canvas(
      document.getElementById("pdf"),
      configuracionCanvas
    );
    let imagenBase64 = canvas.toDataURL("image/jpeg", 1.0);
    pdf.addImage(imagenBase64, "JPEG", 0, 0, width, height, undefined, "FAST");
    return pdf;
  }

  public async fichaExiste(keyObra: string): Promise<boolean> {
    let documentos: DocumentoObra[] = await this.documentoObraService
      .findByKeyObra(keyObra)
      .pipe(take(1))
      .toPromise();
    let ficha: DocumentoObra = documentos.find(
      (d: DocumentoObra) => d.tipo === "ficha"
    );
    return documentos.find((d: DocumentoObra) => d.tipo === "ficha")
      ? true
      : false;
  }

  public async descargarKml() {
    this.elementosObra = await this.capaService
      .findByKeyLevantamientoObra(
        this.obraSeleccionada.obra.keyLevantamientoObra
      )
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.kmlUtils.descargarKml(this.elementosObra[0].coordenadas);
  }

  public descargarPowerPoint() {
    this.pptxUtils.descargarPowerPointFichaTecnica(this.obraSeleccionada);
  }

  public guardarFormato(): void {
    this.guardarFormatoListener.emit(this.obraSeleccionada.obra);
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public ngOnDestroy(): void {
    if (this.suscripcionStorage) {
      this.suscripcionStorage.unsubscribe();
    }
  }
}
